<template>
  <div class="LogoSpread">
    <div v-for="item in content.logos" :key="item._key" :class="{ logoHiddenOnMobile: item.hiddenOnMobile }">
      <SanityImage :asset="item.logo.asset" :alt="item.title" class="logoImage" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>

<style scoped>

.LogoSpread {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--spacing-13) var(--spacing-12);
}

.logoHiddenOnMobile {
  display: none;
}

.logoImage {
  height: 50px;
}

@media (--screen-lg) {
  .logoHiddenOnMobile {
    display: block;
  }
}
</style>
